import { BoxProgrammationSessionHeader } from "@/modules/boxProgrammationSessions/components/boxProgrammationSessionHeader"
import { BoxProgrammationSessionsCalendar } from "@/modules/boxProgrammationSessions/components/boxProgrammationSessionsCalendar"
import { cn } from "@/modules/lib/utils"
import { Path } from "@/modules/navigation/routes"
import { LoadingSpinner } from "@/modules/ui/components/loading"
import { CalendarProvider } from "@modules/calendar/context/calendarContext"
import dayjs from "dayjs"
import { Suspense } from "react"
import { useLocation, useNavigate, useParams } from "react-router"

export function BoxProgrammationSessionsPage({ className, ...props }: React.ComponentProps<"div">) {
  const { boxProgramId } = useParams()
  const navigate = useNavigate()
  const location = useLocation() as { state?: { selectedDate?: string } }

  if (!boxProgramId) {
    void navigate(Path.Box.Planning)
    return null
  }

  return (
    <CalendarProvider
      initialDate={dayjs(location.state?.selectedDate).startOf("day")}
      defaultDisplayDetailedEvents={false}
      defaultView="dayGridWeek"
      isUndated={false}
    >
      <div
        className={cn(
          "flex h-full w-full min-w-280 flex-col gap-10 px-6 py-6 lg:mx-auto 2xl:w-8/10 2xl:px-0",
          className,
        )}
        {...props}
      >
        <BoxProgrammationSessionHeader />
        <Suspense fallback={<LoadingSpinner />}>
          <BoxProgrammationSessionsCalendar boxProgramId={boxProgramId} />
        </Suspense>
      </div>
    </CalendarProvider>
  )
}
